module.exports = __webpack_public_path__ + "static/media/sample_lmfreights_general.b8b13e4c.csv";